'use strict';
import 'reflect-metadata';
import './polyfills';
import './vendor';

import * as angular from 'angular';

import { enableProdMode, PlatformRef, StaticProvider } from '@angular/core';
import { downgradeModule } from '@angular/upgrade/static';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

import { appModuleAngularJS } from '../noc/noc';

import '../noc/dashboard/index.ts';  // TODO check why it can't be a module
import { UrlService, UIRouter } from '@uirouter/core';

if (environment.production) {
  enableProdMode();
}

const bootstrapFn = (extraProviders: StaticProvider[]) => {
  const platformRef: PlatformRef = platformBrowserDynamic(extraProviders);
  return platformRef.bootstrapModule(AppModule);
}
  

appModuleAngularJS.config(['$urlServiceProvider', ($urlService: UrlService) => $urlService.deferIntercept()]);

angular.bootstrap(document.body, [
  appModuleAngularJS.name, 
  downgradeModule(bootstrapFn)
  ]) ;

  const injector: angular.auto.IInjectorService = angular.element(document.body).injector();

  const urlService: UrlService = injector.get('$urlService');
  
  setTimeout(() => {
      // setTimeout needed to allow angular routes to initialize after refresh
      urlService.listen();
      urlService.sync();
  });
